import HeadsetMicIcon from "@material-ui/icons/HeadsetMic";
import LocalShippingOutlinedIcon from "./Icons/LocalShippingOutlinedIcon";
import LocalGasStationOutlinedIcon from "@material-ui/icons/LocalGasStationOutlined";
import RestaurantOutlinedIcon from "@material-ui/icons/RestaurantOutlined";
import TimerOutlinedIcon from "@material-ui/icons/TimerOutlined";
import FlagOutlined from "@material-ui/icons/FlagOutlined";
import KeyboardReturnOutlined from "@material-ui/icons/KeyboardReturnOutlined";
import CheckCircleOutlineOutlined from "@material-ui/icons/CheckCircleOutlineOutlined";
import RestBreakIcon from "@material-ui/icons/AirlineSeatReclineExtra";
import TrailerDropHookIcon from "./Icons/TrailerDropHookIcon";
import RouteStartedIcon from "./Icons/RouteStartedIcon";
import DueTimeIcon from "./Icons/DueTimeIcon";
import LateByIcon from "./Icons/LateByIcon";
import UndoIcon from "./Icons/UndoIcon";
import NextPlanIcon from "./Icons/NextPlanIcon";
import BobtailIcon from "./Icons/BobtailIcon";
import FileUploadIcon from "./Icons/FileUploadIcon";
import DisbledDefaultIcon from "./Icons/DisbledDefaultIcon";
import ForkRightIcon from "./Icons/ForkRightIcon";
import LogoutIcon from "./Icons/LogoutIcon";
import EnterTerminalIcon from "./Icons/EnterTerminalIcon";
import { ALL_DRIVER_STATUS, STOP_TYPES } from "../../constants";
import CheckBoxOutlined  from "@material-ui/icons/CheckBoxOutlined";
import EndTripIcon from "../../../../../../layout/icons/EndTripIcon";

// icons that are imported as svgs are available in version 5 of material ui icons , but since project doesnt supports it right now , we are using svgs instead.
//once the material ui is updated , we can use the icons from library instead of importing as svgs

const getStopTypeClass = (currentStop) => {
  if (!currentStop?.stopType) {
    return null;
  }
  return currentStop.stopType === STOP_TYPES.DELIVERY
    ? "driver-status-stopType driver-status-stopType-delivery"
    : "driver-status-stopType ";
};

const getFormattedDriverStatus = (driverStatus) => {
  if (!driverStatus) {
    return driverStatus;
  }
  const status = driverStatus.split(' ')[0];
  //TrailerHooked/TrailerDropped status will be coming in this formate "TrailerHooked number" "TrailerDropped number"
  return [
    ALL_DRIVER_STATUS.TrailerHooked,
    ALL_DRIVER_STATUS.TrailerDropped,
    ALL_DRIVER_STATUS.DispatchTrailerHook,
    ALL_DRIVER_STATUS.DispatchTrailerDrop
  ].includes(status)
    ? status
    : driverStatus;
}

const getIsDelayType = (delays, driverStatus) =>
  delays?.some((d) => d.delayType === driverStatus);

export const getDriverStatusIcon = ({driverStatus, currentStop, delays, ...others}) => {
  const {customStyle} = others ?? {};
  const formattedDriverStatus = getFormattedDriverStatus(driverStatus);
  const isDelayType = getIsDelayType(delays, formattedDriverStatus);
  switch (formattedDriverStatus) {
    case ALL_DRIVER_STATUS.Dispatched:
      return <HeadsetMicIcon className={`${customStyle} driver-status-icon`} {...others}/>;
    case ALL_DRIVER_STATUS.EnrouteToStop:
    case ALL_DRIVER_STATUS.ArrivedAtStop:
      return (
        <div className={getStopTypeClass(currentStop)}>
          <LocalShippingOutlinedIcon className="driver-status-icon" {...others}/>
        </div>
      );
    case ALL_DRIVER_STATUS.TrailerDropped:
    case ALL_DRIVER_STATUS.TrailerHooked:
    case ALL_DRIVER_STATUS.DispatchTrailerHook:
    case ALL_DRIVER_STATUS.DispatchTrailerDrop:
      return <TrailerDropHookIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.ArrivedAtTerminal:
      return <FlagOutlined className={`${customStyle} driver-status-icon`} {...others}/>;
    case ALL_DRIVER_STATUS.ReturnToTerminal:
      return <KeyboardReturnOutlined className={`${customStyle} driver-status-icon`} {...others}/>;
    case ALL_DRIVER_STATUS.FuelBreak:
      return <LocalGasStationOutlinedIcon className={`${customStyle} driver-status-icon`} {...others}/>;
    case ALL_DRIVER_STATUS.LunchBreak:
      return <RestaurantOutlinedIcon className={`${customStyle} driver-status-icon`} {...others}/>;
    case ALL_DRIVER_STATUS.RestBreak:
      return <RestBreakIcon className={`${customStyle} driver-status-icon`} {...others} />
    case ALL_DRIVER_STATUS.DriverClockedIn:
      return <TimerOutlinedIcon className={`${customStyle} driver-status-icon`} {...others}/>;
    case ALL_DRIVER_STATUS.RouteStarted:
    case ALL_DRIVER_STATUS.DispatchStartTrip:
      return <RouteStartedIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.DueTime:
      return <DueTimeIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.LateBy:
      return <LateByIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.StopCompleted:
    case ALL_DRIVER_STATUS.StopsCompleted:
      return (
        <CheckCircleOutlineOutlined
          className={`${customStyle} driver-status-icon`}
          {...others}
        />
      );
    case ALL_DRIVER_STATUS.DispatchDeliveryCompleted:
      return <CheckCircleOutlineOutlined className={`${customStyle} driver-status-icon`} {...others}/>;
    case ALL_DRIVER_STATUS.UndoArriveAtStop:
      return <UndoIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.NextStopChanged:
      return <NextPlanIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.Bobtail:
      return <BobtailIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.BillsMoved:
      return <FileUploadIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.DispatchNoFreightPickedup:
    case ALL_DRIVER_STATUS.NoFreightPickedUp:
      return <DisbledDefaultIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.ActiveRouteChanged:
      return <ForkRightIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.LeaveTerminal:
      return <LogoutIcon className="driver-status-icon" {...others}/>;
    case ALL_DRIVER_STATUS.EnterTerminal:
      return <EnterTerminalIcon className="driver-status-icon" {...others} />
    case ALL_DRIVER_STATUS.PickupCompleted:
    case ALL_DRIVER_STATUS.DispatchPickupCompleted:
      return <CheckBoxOutlined className={`${customStyle} driver-status-icon`} {...others}/>;
    case ALL_DRIVER_STATUS.EndOfTrip:
      return <EndTripIcon  {...others}/>
    default:
      return isDelayType
        ? <LateByIcon className={`${customStyle} driver-status-icon`} {...others}/>
        : null;
  }
};
